/**
 * Mappe les messages d'erreur anglais de Supabase Auth vers le français.
 */
export function getAuthErrorMessage(error: any): string {
  if (!error) return "Une erreur est survenue";

  const message = typeof error === 'string' ? error : error.message || "Une erreur est survenue";

  // Messages d'exigences de mot de passe
  if (message.includes("Password should contain at least one character of each")) {
    return "Le mot de passe doit contenir au moins un caractère de chaque groupe : minuscules, majuscules, chiffres et caractères spéciaux (ex: abcdefghijklmnopqrstuvwxyz, ABCDEFGHIJKLMNOPQRSTUVWXYZ, 0123456789, !@#$%^&*()_+-=[]{};':\"|<>?,./`~).";
  }

  if (message.includes("Password should be at least")) {
    const length = message.match(/\d+/)?.[0] || "6";
    return `Le mot de passe doit contenir au moins ${length} caractères.`;
  }

  // Erreurs d'authentification classiques
  if (message.includes("Invalid login credentials") || message.includes("Invalid credentials")) {
    return "Identifiants de connexion invalides.";
  }

  if (message.includes("User already registered") || message.includes("User already exists")) {
    return "Un utilisateur avec cet email existe déjà.";
  }

  if (message.includes("Email not confirmed")) {
    return "Veuillez confirmer votre adresse email avant de vous connecter.";
  }

  if (message.includes("Too many requests")) {
    return "Trop de tentatives. Veuillez réessayer plus tard.";
  }

  if (message.includes("Invalid refresh token")) {
    return "Session expirée. Veuillez vous reconnecter.";
  }

  if (message.includes("New password should be different from the old password")) {
    return "Le nouveau mot de passe doit être différent de l'ancien.";
  }

  return message; // Retourne le message original si aucune correspondance n'est trouvée
}
